import React, {useState, useEffect} from 'react'
import _ from 'lodash'
import './VideoPager.scss'
import Button from '../../partials/Button'
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer'
import Scroll from '../../partials/Scroll/Scroll'

const VideoIntro = props => {
    const [enableContinue, setEnableContinue] = useState(true);
    const [videoStarted, setVideoStarted] = useState(false);
    const [selfData, setSelfData] = useState({
        headerText:null,
        onScreenText:null,
        prompt:null,
        videoSource:null,
        class:null,
    });

    // useEffect(()=>{
    //     setTimeout(()=>{
    //         const video = document.getElementById("video-intro-player");
    //         if (video && video.readyState !== 4 ) {
    //             // it's NOT loaded
    //             setEnableContinue(true)
    //         }
    //     }, 3000)
    // }, [])

    useEffect(()=>{
        if(!props.data) return;
        let temp = _.cloneDeep(selfData);
        Object.keys(props.data).forEach(key=> {
            temp[key] = props.data[key];
        })
        setSelfData(temp);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.data]);

    const onVideoPlaying = () => {
        setVideoStarted(true);
    }
    
    const onVideoEnd = () => {
        setVideoStarted(false);
        setEnableContinue(true);
    }

    const onContinueClick = () => {
        if(enableContinue){
            props.onComplete();
        }
    }

    const onPlayVidClick = () => {
        let vid = document.getElementById("video-intro-player"); 
        vid.play();
    }
    
    return (
        <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
            <div className="back-btn-container">
                <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
            </div>
            <div className={`VideoIntro ${selfData.class}`}>
            {/* <div className={`bg-1`}></div>
            <div className={`bg-2`}></div>
            <div className={`bg-3`}></div> */}

                <div className={'text-box'}>
                    <div className={`header blue-box`}>
                        {selfData.headerText && <h1>{selfData.headerText}</h1>}
                        <Scroll>
                            {selfData.onScreenText && <div className={'on-screen-text'} dangerouslySetInnerHTML={{
                                __html: selfData ? selfData.onScreenText : ''
                            }}></div>}
                        </Scroll>
                    </div>
                    <div className="instructions white-box">
                        <span className="instruction-text">{selfData.prompt}</span>
                    </div>
                </div>

            <div className={`scrim ${videoStarted ? 'showScrim' : ''}`}></div>
            
            <div className="VideoPlayer">
                <video className={`${videoStarted ? 'playing' : ''} ${enableContinue ? 'done' : ''}`} width={'550'} controls controlsList="nodownload" disablePictureInPicture onPlaying={onVideoPlaying} onEnded={onVideoEnd} id={'video-intro-player'} poster='img/video-poster.png' >
                    <source src={selfData.videoSource} type="video/mp4"></source>
                    Your browser does not support the video tag.
                </video> 
                {/* <div className="FPO">FPO</div> */}
                <div className={`play-check-btn ${enableContinue ? 'checked' : ''} ${videoStarted ? 'playing' : ''}`} onClick={onPlayVidClick}></div>
            </div>
            <div className={`btn-container ${enableContinue ? 'enabled' : 'disabled'}`}>
                <Button className={`next-button`} onClick={onContinueClick} text={'Next'}></Button>
            </div>
        </div>
        </InteractionContainer>
    )
}

export default VideoIntro


